import { ui } from "@patient-watch/ui";
import { cn } from "@/lib/utils";

interface Props {
    children: React.ReactNode | string;
    asChild?: boolean;
    disabled?: boolean;
    className?: string;
}
const EditButton = ({ children, asChild = false, disabled = false, className }: Props) => {
    return (
        <ui.Button
            asChild={asChild && !disabled}
            variant="link"
            size="sm"
            disabled={disabled}
            className={cn(
                "my-0 w-fit min-h-0 text-sm",
                asChild && !disabled ? "h-auto p-0" : "px-1 py-0 h-auto",
                className
            )}
            data-testid={asChild ? undefined : "edit-button"}
        >
            {children}
        </ui.Button>
    );
};

export default EditButton;
